export default __webpack_public_path__ + "static/media/clapping.2b4c03a6.mp3";